import { CustomBaseStore } from '@city/const';
import { Action } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { BASE_STORE } from '../city-state';

export const LOAD_BASE_STORE = '[City] BaseStore Load';
export const LOAD_BASE_STORE_SUCCESS = '[City] BaseStore Load Success';
export const LOAD_BASE_STORE_FAIL = '[City] BaseStore Load Fail';
export const SET_ACTIVE_BASE_STORE = '[City] Set Active BaseStore';
export const DELAYED_SET_ACTIVE_BASE_STORE = '[City] Delayed Set Active BaseStore';
export const CLEAR_TEMPORARY_ACTIVE_BASE_STORE = '[City] clear temporary base store';

export class LoadBaseStores extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_BASE_STORE;

  constructor() {
    super(BASE_STORE);
  }
}

export class LoadBaseStoresFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_BASE_STORE_FAIL;

  constructor(public payload: any) {
    super(BASE_STORE, payload);
  }
}

export class LoadBaseStoresSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_BASE_STORE_SUCCESS;

  constructor(public payload: CustomBaseStore[]) {
    super(BASE_STORE);
  }
}

export class SetActiveBaseStore implements Action {
  readonly type = SET_ACTIVE_BASE_STORE;

  constructor(public payload: string) {}
}

// Временно сохраняет отдельно новый стор и в эффекте на переход по роутеру уже окончательно.
export class DelayedSetActiveBaseStore implements Action {
  readonly type = DELAYED_SET_ACTIVE_BASE_STORE;

  constructor(public payload: string) {}
}

// удалаяет времмменоую запись о сторе, после безопасной установки активного стора
export class ClearTemporaryBaseStore implements Action {
  readonly type = CLEAR_TEMPORARY_ACTIVE_BASE_STORE;
}

export type BaseStoreAction =
  | LoadBaseStores
  | LoadBaseStoresFail
  | LoadBaseStoresSuccess
  | SetActiveBaseStore
  | DelayedSetActiveBaseStore
  | ClearTemporaryBaseStore;
